import * as PopoverPrimitive from "@radix-ui/react-popover"
import type { ComponentProps } from "react"

import { cn } from "~/lib/utils"

function Popover({ ...props }: ComponentProps<typeof PopoverPrimitive.Root>) {
	return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopoverTrigger({
	...props
}: ComponentProps<typeof PopoverPrimitive.Trigger>) {
	return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
	className,
	align = "center",
	sideOffset = 4,
	size = "default",
	layout = "default",
	container,
	...props
}: ComponentProps<typeof PopoverPrimitive.Content> &
	Pick<ComponentProps<typeof PopoverPrimitive.Portal>, "container"> & {
		size?: "default" | "sm" | "md" | "lg" | "xl" | "fit"
		layout?: "default" | "panel"
	}) {
	return (
		<PopoverPrimitive.Portal container={container}>
			<PopoverPrimitive.Content
				data-slot="popover-content"
				align={align}
				sideOffset={sideOffset}
				className={cn(
					"bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-w-[calc(100vw-2rem)] rounded-lg surface-floating outline-hidden",
					size === "default" && "w-72",
					size === "sm" && "w-48",
					size === "md" && "w-50",
					size === "lg" && "w-75",
					size === "xl" && "w-[30rem]",
					size === "fit" && "w-fit",
					layout === "panel" &&
						"flex max-h-(--radix-popover-content-available-height) flex-col gap-4 overflow-y-auto p-3",
					className
				)}
				{...props}
			/>
		</PopoverPrimitive.Portal>
	)
}

function PopoverAnchor({
	...props
}: ComponentProps<typeof PopoverPrimitive.Anchor>) {
	return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
